export const GET_PROJECT_CLIENT_SETTINGS_QUERY_KEY = 'getProjectClientSettings';
